/**
 * Farlo UI | Lightbox
 *
 * @author Farlo
 */

class FarloUiLightbox {
	constructor(element) {
		this.element = element;
		this.lightbox = document.querySelector('.site-farlo-ui-lightbox');
		this.lightboxContent = this.lightbox.querySelector('.site-farlo-ui-lightbox__content');
		this.lightboxContentInner = this.lightbox.querySelector('.site-farlo-ui-lightbox__content-inner');
		this.closeButton = this.lightbox.querySelector('.site-farlo-ui-lightbox__close');
		this.backdrop = this.lightbox.querySelector('.site-farlo-ui-lightbox__backdrop');

		this.element.addEventListener('click', this.openLightbox.bind(this));
		this.closeButton.addEventListener('click', this.closeLightbox.bind(this));
		this.backdrop.addEventListener('click', this.closeLightbox.bind(this));
		this.lightbox.addEventListener('keydown', this.handleKeydown.bind(this));

		// Add ARIA attributes
		this.element.setAttribute('aria-haspopup', 'dialog');
		this.lightbox.setAttribute('role', 'dialog');
		this.lightbox.setAttribute('aria-modal', 'true');
		this.lightbox.setAttribute('aria-hidden', 'true');
		this.lightboxContent.setAttribute('role', 'document');
		this.closeButton.setAttribute('aria-label', 'Close Lightbox');
	}

	helperIsImageType(src) {
		// Check if the source URL ends with common image extensions
		return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(src);
	}

	helperValueNullOrUndefined(checkedElement) {
		return checkedElement && typeof checkedElement !== 'undefined' && typeof checkedElement.value !== 'undefined' && checkedElement.value !== '';
	}

	openLightbox() {
		if (!this.element.nextElementSibling && !this.element.nextElementSibling.childNodes && !this.element.nextElementSibling.classList.contains('site-farlo-ui-lightbox')) {
			this.lightboxContentInner.innerHTML = '';
		}

		if (this.helperValueNullOrUndefined(this.element.nextElementSibling)) {
			this.lightboxContentInner.innerHTML = this.element.nextElementSibling.value;

			this.lightbox.classList.add('site-farlo-ui-lightbox--active');

			this.lightbox.removeAttribute('aria-hidden');
			this.lightbox.focus();

			document.querySelectorAll('[farlo-event]').forEach(function(_sel) {
				_sel.addEventListener('click', function(e) {
					if (e.href) {
						e.preventDefault();
					}

					window._farlo.events.push(_sel.dataset.c, _sel.dataset.a, _sel.dataset.l || '', _sel.dataset.v || '');

					if (e.href) {
						document.location.href = e.href;
					}
				});
			});
			return;
		}

		if (this.element.nextElementSibling && this.element.nextElementSibling.childNodes && this.element.nextElementSibling.classList.contains('site-farlo-ui-lightbox')) {
			this.lightbox.classList.add('site-farlo-ui-lightbox--active');

			this.lightbox.removeAttribute('aria-hidden');

			document.querySelectorAll('[farlo-event]').forEach(function(_sel) {
				_sel.addEventListener('click', function(e) {
					if (e.href) {
						e.preventDefault();
					}

					window._farlo.events.push(_sel.dataset.c, _sel.dataset.a, _sel.dataset.l || '', _sel.dataset.v || '');

					if (e.href) {
						document.location.href = e.href;
					}
				});
			});
			return;
		}

		if (this.element && typeof this.element.getAttribute('data-src') !== 'undefined' && this.element.getAttribute('data-src') !== '') {
			const src = this.element.getAttribute('data-src');

			if (this.helperIsImageType(src)) {
				// Create an image element
				const image = document.createElement('img');
				image.src = src;
				image.className = 'site-farlo-ui-lightbox__image';

				// Clear previous content
				this.lightboxContentInner.innerHTML = '';
				this.lightboxContentInner.appendChild(image);
			} else {
				// Create an iframe element
				const iframe = document.createElement('iframe');
				const iframeWrapper = document.createElement('div');
				iframe.src = src;
				iframeWrapper.className = 'site-farlo-ui-lightbox__iframe-wrapper';
				iframe.className = 'site-farlo-ui-lightbox__iframe-wrapper-frame';
				iframe.setAttribute('frameborder', '0');
				iframe.setAttribute('allowfullscreen', 'true');

				// Clear previous content
				this.lightboxContentInner.innerHTML = '';
				iframeWrapper.appendChild(iframe);
				this.lightboxContentInner.appendChild(iframeWrapper);
			}

			// Show the lightbox
			this.lightbox.classList.add('site-farlo-ui-lightbox--active');

			// Update ARIA attributes
			this.lightbox.removeAttribute('aria-hidden');
			this.lightbox.focus();
		}
	}

	closeLightbox() {
		// Hide the lightbox
		this.lightbox.classList.remove('site-farlo-ui-lightbox--active');

		// Update ARIA attributes
		setTimeout(() => {
			if (!this.element.nextElementSibling && !this.element.nextElementSibling.childNodes && !this.element.nextElementSibling.classList.contains('site-farlo-ui-lightbox')) {
				this.lightboxContentInner.innerHTML = '';
			}
			this.lightbox.setAttribute('aria-hidden', 'true');
			this.element.focus();
		}, 300);
	}

	handleKeydown(event) {
		if (event.key === 'Escape') {
			this.closeLightbox();
		}
	}
}

export default FarloUiLightbox;
